import axios from "axios";
import { API_URL } from "./index";
class RelatedFilmService {
    getByAdvertisement = (id) => {
        const url = API_URL.advertizementFilmAssociation("find-by-advertizement");
        return axios.get(url, { params: { advId: id } }).then((response) => response);
    };
    getRelatedFilm = (id) => {
        const url = API_URL.advertizementFilmAssociation(id);
        return axios.get(url).then((response) => response);
    };

    createRelatedFilm = (body) => {
        const url = API_URL.advertizementFilmAssociation();
        return axios.post(url, body).then((response) => response);
    };
    deleteRelatedFilm = (id) => {
        const url = API_URL.advertizementFilmAssociation(id);
        return axios.delete(url).then((response) => response);
    };
    editRelatedFilm = (body) => {
        const url = API_URL.advertizementFilmAssociation();
        return axios.put(url, body).then((response) => response);
    };
}

export default new RelatedFilmService();
